import * as React from 'react';

function MultipleChoiceBlockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M4 5h16v2H4zM4 11h16v2H4zM4 17h10v2H4z" fill="#6C7680" />
		</svg>
	);
}

export default MultipleChoiceBlockIcon;
